import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "min"]

import { format, parse } from 'date-fns';



export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const todayFormatted = format(new Date(), 'yyyy-MM-dd');

const parsedModel = props.modelValue
  ? format(parse(props.modelValue, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd')
  : todayFormatted;

function updateDate(event: Event) {
  const target = event.target as HTMLInputElement;
  const value = format(new Date(target.value), 'dd-MM-yyyy');
  emit('update:modelValue', value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "date",
    value: _unref(parsedModel),
    onInput: _cache[0] || (_cache[0] = ($event: any) => (updateDate($event))),
    min: _unref(todayFormatted),
    class: "rounded-lg border border-[#333] bg-[#1A1A1A] text-white px-4 py-3 w-full focus:border-[#C59C2F] focus:outline-none transition-all"
  }, null, 40, _hoisted_1))
}
}

})